import NavIcon from "../components/nav-icon"
import BannerRight from "../components/banner-right"
import WrapperjsTest from "../components/reactjstest/wrapper-test"


const ReactjsTest = ()=> {
    return (
        <>
        <NavIcon/>
        <BannerRight/>
        <WrapperjsTest/>
        
        </>
    )
}
export default ReactjsTest